<template>
    <v-list-tile v-if="itemVisibility" @click.prevent="changePage" :class="activeClass">
      <v-list-tile-action>
        <v-icon :class="activeClass" v-html="MenuItem.icon"></v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
          <v-list-tile-title v-text="MenuItem.name"></v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'menu-item',
  props: ['MenuItem'],
  methods: {
    changePage() {
      this.$router.push({
        path: this.MenuItem.slug,
      });
    },
  },
  computed: {
    ...mapGetters('user', [
      'details',
      'role',
    ]),
    itemVisibility() {
      return (this.isAdmin && this.MenuItem.role === 'admin') || this.MenuItem.role === 'any';
    },
    isAdmin() {
      return this.role === 'admin' || this.role === 'super-admin';
    },
    activeClass() {
      const activePath = this.MenuItem.routeName;
      const currentRoute = this.$route.name;
      const isActive = activePath === currentRoute;
      return isActive ? 'primary--text' : '';
    },
  },
};
</script>
